"use client";
import useLocalStorage, { deleteFromStorage, writeStorage } from "@rehooks/local-storage";
import { AUTH_DEVICE_TOKEN, AUTH_IDENTITY_TOKEN } from "@/utils/constants/storageKeys";
import { createContext, Dispatch, SetStateAction, useCallback, useContext, useEffect, useMemo, useState } from "react";
import DTC from "@/utils/models/DTC";
import KyApiClient from "../services/apiClient/KyApiClient";
import DeviceTokenGenerateResponseDto from "@/projectRoot/api-client/interfaces/response/auth/DeviceTokenGenerateResponse.dto";
import { DevicePlatform } from "@/projectRoot/api-client/interfaces/models/webshop/cart/Cart.dto";

export const defaultContext: ApiClientContextProps = { 

};

export const ApiClientContext = createContext<ApiClientContextProps>(defaultContext);

export interface ApiClientContextProps {
  apiClient?: KyApiClient;
  language?: string;
  setLanguage?: Dispatch<SetStateAction<string>>;
}

export type ContextProps = Partial<ApiClientContextProps> & { children?: any };

export default function ApiClientProvider({ children, language }: ContextProps) {

  const [deviceTokenData] = useLocalStorage<DeviceTokenGenerateResponseDto>(AUTH_DEVICE_TOKEN);

  const [identityTokenData] = useLocalStorage<{identity_token: string, expires_at: string}>(AUTH_IDENTITY_TOKEN);

  const options = useMemo(() => ({
    prefixUrl: process.env.NEXT_PUBLIC_API_BASE_URL ?? '/api',
    headers: {
      'x-device-token': deviceTokenData?.token ?? '',
      'authorization': identityTokenData?.identity_token ? `Bearer ${identityTokenData.identity_token}` : '', // mozda da se iskljuci i da se salje samo identity-token
      'accept': 'application/json',
      'accept-language': language,
      'backoffice-service-token': process.env.NEXT_PUBLIC_SERVICE_TOKEN ?? '',
    }
  }), [deviceTokenData, identityTokenData, language]);

  const apiClient = useMemo(() => KyApiClient.createApiClient(language, options), [language, options]);

  //FUNCTIONS

  const initAuthDeviceToken = useCallback(async () => {
    if (!deviceTokenData) {
      const dtc = new DTC();
      // console.log(dtc.gech(window.navigator.userAgent), window.navigator.userAgent)
      const deviceTokenGenerateResponse = await apiClient.auth().deviceTokenGenerate({
        challenge: dtc.gech(window.navigator.userAgent),
        device_id: window.navigator.userAgent,
        platform: DevicePlatform.WEB,
      });
      if (deviceTokenGenerateResponse.data) {
        writeStorage(AUTH_DEVICE_TOKEN, deviceTokenGenerateResponse.data);
      }
    }
  }, [deviceTokenData]);

  // EFFECTS
  useEffect(() => {
    if(deviceTokenData){
      if(new Date().getTime() > new Date(deviceTokenData.expires_at).getTime()){
        deleteFromStorage(AUTH_DEVICE_TOKEN);
      }
    }
  }, []);

  useEffect(() => {
    if(typeof window !== 'undefined'){
      initAuthDeviceToken();
    }
  }, [initAuthDeviceToken]);


  return (
    <ApiClientContext.Provider value={{ 
      apiClient: apiClient, 
      language: language,
    }}>
      {children}
    </ApiClientContext.Provider>
  )
}

export function useApiClient(): ApiClientContextProps {
    return useContext<ApiClientContextProps>(ApiClientContext);
}